export const APP_SETTINGS = ['Account2Config'];

export default APP_SETTINGS;
